export const DEFAULT_EMBEDDING_MODEL = 'text-embedding-3-small'

export const createDefaultProviderForm = (providerParams = {}) => ({
  provider: 'qdrant',
  provider_params: {
    embeddingModel: DEFAULT_EMBEDDING_MODEL,
    ...providerParams
  }
})
